import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Input, InputGroupAddon, InputGroupText } from 'reactstrap'
import {
  addCourseComment,
  onChangeComment,
  setNewCommentTextboxActive,
} from 'store/Course/actions'
import Loader from 'views/pages/Loader'
import defaultAvatar from '../../../../../../assets/img/brand/img_avatar.png'
import { handleCollapsed } from 'store/Course/actions'
import { cancelEdit } from 'store/Course/actions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { deleteCourseComment } from 'store/Course/actions'
import { addCommentReplies } from 'store/Course/actions'
import { addReplyOnClick } from 'store/Course/actions'
import { setReplyTextboxActive } from 'store/Course/actions'
import { handleUpdateCommentReply } from 'store/Course/actions'
import { cancelEditReply } from 'store/Course/actions'
import { updateCourseComment } from 'store/Course/actions'
import { fetchCourseComments } from 'store/Course/actions'
import { setCurrentComment } from 'store/Course/actions'
import {
  faPaperPlane,
  faPencil,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { handleUpdateComment } from 'store/Course/actions'
import { searchComments } from 'store/Course/actions'
import { setCurrentReply } from 'store/Course/actions'

function DiscussionForum({ language, courseId }) {
  const dispatch = useDispatch()
  const {
    isNewCommentActive,
    courseComments,
    isLoadingComments,
    currentComment,
    currentReply,
    isEditTextboxActive,
    isReplyTextboxActive,
    isNewCommentDisabled,
    isReplyCommentDisabled,
    isEditCommentDisabled,
    searchValueComments,
  } = useSelector((store) => store.courses)
  const { user } = useSelector((store) => store.auth)

  useEffect(() => {
    dispatch(fetchCourseComments(courseId))
  }, [dispatch, courseId])

  return (
    <>
      <div className='d-flex align-items-center'>
        <button
          onClick={() => dispatch(setNewCommentTextboxActive(true))}
          className='btn btn-info'
        >
          New Comment
        </button>

        <div
          className='d-flex align-items-center ml-4'
          style={{ height: '43px' }}
        >
          <Input
            className='form-control-sm searchbar h-100'
            type='search'
            placeholder={
              language.discussions ? language.discussions.search_topic : null
            }
            value={searchValueComments}
            onChange={(event) => dispatch(searchComments(event.target.value))}
          />
          <InputGroupAddon
            className='h-100'
            addonType='append'
            // onClick={props.onClick}
          >
            <InputGroupText className='bg-info wFull flex justifyCenter itemsCenter cursorPointer'>
              <i className='fas fa-search text-white' />
            </InputGroupText>
          </InputGroupAddon>
        </div>
      </div>

      {isNewCommentActive ? (
        <NewCommentTextbox user={user} language={language} />
      ) : null}

      <div className='row'>
        <div className='col-12'>
          <div className='discussion-topic-header discussion-topic-mobile'>
            <div className='row justify-content-between'>
              <div className='col-6'></div>
              <div className='col-6'>
                <p className='total-nr-topics'>
                  {courseComments && courseComments.length + ' '}{' '}
                  {language.discussions ? language.general.comments : null}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {courseComments && courseComments.length > 0 ? (
        <CourseForumThreads
          user={user}
          list={courseComments}
          language={language}
          currentComment={currentComment}
          currentReply={currentReply}
          isEditTextboxActive={isEditTextboxActive}
          isReplyTextboxActive={isReplyTextboxActive}
          searchValueComments={searchValueComments}
          // setEditTextboxActive={props.setEditTextboxActive}
          // onChangeCommentReply={props.onChangeCommentReply}
          isNewCommentDisabled={isNewCommentDisabled}
          isReplyCommentDisabled={isReplyCommentDisabled}
          isEditCommentDisabled={isEditCommentDisabled}
        />
      ) : isLoadingComments ||
        (courseComments && courseComments.length !== 0) ? (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
          <Loader />
        </div>
      ) : (
        <div className='text-center'>
          <p>Be the first to leave a comment!</p>
        </div>
      )}
    </>
  )
}

const CourseForumThreads = (props) => {
  const dispatch = useDispatch()
  const [replyingComment, setReplyingComment] = useState(null)

  const replyComment = (item) => {
    setReplyingComment({ ...item })
    dispatch(setCurrentComment(item))
    dispatch(setReplyTextboxActive(true))
  }

  return (
    <div className='discussion-topic-wraper'>
      <ul className='discussion-topic-list'>
        {props.list
          .filter(
            (item) =>
              item.comment &&
              item.comment
                .toLowerCase()
                .indexOf(props.searchValueComments.toLowerCase()) !== -1
          )
          .map((item, index) => (
            <li key={index}>
              <div className='row'>
                <div className='col-2'>
                  <div className='topic-avatar-wrapper'>
                    <img
                      src={item.avatar ? item.avatar.url : defaultAvatar}
                      alt='avatar'
                      className='avatar-fit'
                    />
                  </div>
                </div>
                <div className='col-10'>
                  <div className='topic-item-info'>
                    <div className='comment-data'>
                      <div className='d-flex align-items-center justify-content-between'>
                        <h3 className='comment-user'>
                          {item.first_name ? item.first_name : null}{' '}
                          {item.first_name ? item.last_name : null}
                        </h3>
                        <div className='comment-options mr-1 d-flex align-items-center'>
                          {item.isEditing ? (
                            <p
                              role='button'
                              onClick={() => dispatch(cancelEdit(item))}
                              className='cancel-edit'
                            >
                              {props.language.general
                                ? props.language.general.cancel
                                : null}
                            </p>
                          ) : null}

                          {props.user.id === item.user_id && !item.isEditing ? (
                            <p
                              onClick={() => {
                                dispatch(setCurrentComment(item))
                                dispatch(handleUpdateComment(item))
                              }}
                              title='Edit'
                              style={{
                                marginRight: '5px',
                                cursor: 'pointer',
                              }}
                              className='icon-mobile'
                            >
                              <FontAwesomeIcon icon={faPencil} />
                            </p>
                          ) : null}
                          {props.user.access === 1 ||
                          props.user.id === item.user_id ? (
                            <p
                              onClick={() =>
                                dispatch(deleteCourseComment(item.id))
                              }
                              title='Delete'
                              style={{ marginRight: '0' }}
                              className='ml-1'
                            >
                              <FontAwesomeIcon
                                style={{
                                  color: '#f54242',
                                  cursor: 'pointer',
                                }}
                                icon={faTrash}
                              />
                            </p>
                          ) : null}
                        </div>
                      </div>
                      {props.currentComment &&
                      props.currentComment.id === item.id &&
                      item.isEditing ? (
                        <UpdateCommentTextbox
                          currentComment={props.currentComment}
                          isEditCommentDisabled={props.isEditCommentDisabled}
                        />
                      ) : (
                        <p className='comment-message'>{item.comment}</p>
                      )}{' '}
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                      <div className='d-flex align-items-center'>
                        <span
                          onClick={() => {
                            dispatch(handleCollapsed(item))
                          }}
                          className='ies-numb-mobile'
                        >
                          {(item.replies && item.replies.length) || 0}{' '}
                          {item.replies && item.replies.length === 1
                            ? 'reply'
                            : 'replies'}
                        </span>
                        <p
                          role='button'
                          className='text-info font-weight-bolder text-sm'
                          //leart
                          onClick={() => replyComment(item)}
                        >
                          {'Reply'}{' '}
                        </p>
                      </div>

                      <span style={{ marginRight: '4px', float: 'right' }}>
                        {props.language.discussions
                          ? props.language.discussions.submitted_on
                          : null}{' '}
                        {item.updated_at.split('T')[0] +
                          ', at ' +
                          item.updated_at.split('T')[1].substring(0, 5)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {item.replies && item.replies.length ? (
                <Replies
                  user={props.user}
                  parentComment={item}
                  isEditTextboxActive={props.isEditTextboxActive}
                  replies={item.replies}
                  language={props.language}
                  // setEditTextboxActive={props.setEditTextboxActive}
                  currentComment={props.currentComment}
                  currentReply={props.currentReply}
                  isEditCommentDisabled={props.isEditCommentDisabled}
                  isReplyCommentDisabled={props.isReplyCommentDisabled}
                />
              ) : null}
              {props.currentComment &&
              props.currentComment.id === item.id &&
              item.replies.length &&
              !item.areRepliesCollapsed ? (
                <span
                  onClick={() => {
                    dispatch(handleCollapsed(item))
                  }}
                  className='view-more-replies view-less'
                >
                  View less replie(s)
                </span>
              ) : null}
              {props.currentComment &&
              item.id === props.currentComment.id &&
              props.isReplyTextboxActive ? (
                <div className='row'>
                  <div className='col-2'>
                    <div className='border-div'></div>
                  </div>
                  <div className='col-10'>
                    <ReplyCommentTextbox
                      replyingTo={item}
                      language={props.language}
                      isReplyTextboxActive={props.isReplyTextboxActive}
                      isReplyCommentDisabled={props.isReplyCommentDisabled}
                    />
                  </div>
                </div>
              ) : null}
            </li>
          ))}
      </ul>
    </div>
  )
}

const UpdateCommentTextbox = (props) => {
  const dispatch = useDispatch()

  const handleKeyDown = (event, commentId) => {
    event.preventDefault()
    event.stopPropagation()
    dispatch(updateCourseComment(commentId))
  }

  return (
    <div className='position-relative'>
      <textarea
        name='comment'
        className='w-100 bg-white p-3 m-1 rounded'
        autoFocus
        rows='1'
        onChange={(event) => dispatch(onChangeComment(event.target.value))}
        defaultValue={props.currentComment.comment}
        onKeyDown={(event) =>
          event.key === 'Enter'
            ? handleKeyDown(event, props.currentComment.id)
            : null
        }
        disabled={props.isEditCommentDisabled}
        onFocus={function (e) {
          var val = e.target.value
          e.target.value = ''
          e.target.value = val
        }}
        style={{ resize: 'none', fontSize: '14px' }}
      ></textarea>
      <span
        className='send-button-update'
        onClick={() => dispatch(updateCourseComment(props.currentComment.id))}
      >
        <FontAwesomeIcon icon={faPaperPlane} />
      </span>
    </div>
  )
}

const Replies = (props) => {
  const dispatch = useDispatch()
  const firstReply = props.replies && props.replies[0]

  let language = {}
  if (props.language) {
    language = props.language
  }

  const handleKeyDownUpdateCommentReply = (event, commentId) => {
    event.preventDefault()
    event.stopPropagation()
    dispatch(updateCourseComment(commentId))
  }

  return props.replies &&
    props.currentComment &&
    props.parentComment.id === props.currentComment.id &&
    !props.parentComment.areRepliesCollapsed ? (
    props.replies.map((item) => (
      <div className='row'>
        <div className='col-2'>
          <div className='border-div reply-border-div'></div>
        </div>
        <div className='col-10'>
          <div className='row replying-item'>
            <div className='col-2'>
              <div className='topic-avatar-wrapper'>
                <img
                  src={item.avatar ? item.avatar.url : defaultAvatar}
                  alt='avatar'
                  className='avatar-fit'
                />
              </div>
            </div>
            <div className='col-10'>
              <div className='topic-item-info'>
                <div className='comment-data '>
                  <div className='d-flex align-items-center justify-content-between'>
                    <h3 className='comment-user replying-item-mobile '>
                      {item.first_name ? item.first_name : null}{' '}
                      {item.first_name ? item.last_name : null}
                    </h3>
                    <div className='comment-options mr-1 d-flex align-items-center'>
                      {item.isEditing ? (
                        <p
                          onClick={() => dispatch(cancelEditReply(item))}
                          className='cancel-edit'
                        >
                          {language.general ? language.general.cancel : null}
                        </p>
                      ) : null}
                      {props.user.id === item.user_id && !item.isEditing ? (
                        <p
                          onClick={() => {
                            dispatch(setCurrentReply(item))
                            dispatch(handleUpdateCommentReply(item))
                          }}
                          title='Edit'
                          style={{ marginRight: '5px', cursor: 'pointer' }}
                          className='icon-mobile'
                        >
                          <FontAwesomeIcon icon={faPencil} />
                        </p>
                      ) : null}
                      {props.user.access === 1 ||
                      props.user.id === item.user_id ? (
                        <p
                          onClick={() => dispatch(deleteCourseComment(item.id))}
                          title='Delete'
                          style={{ marginRight: '0' }}
                          className='icon-mobile'
                        >
                          <FontAwesomeIcon
                            icon={faTrash}
                            className='ml-1'
                            style={{ color: '#f54242', cursor: 'pointer' }}
                          />
                        </p>
                      ) : null}
                    </div>
                  </div>
                  {props.currentReply &&
                  props.currentReply.id === item.id &&
                  item.isEditing ? (
                    <UpdateReplyTextbox
                      onChangeComment={props.onChangeComment}
                      handleKeyDown={handleKeyDownUpdateCommentReply}
                      currentComment={props.currentComment}
                      currentReply={props.currentReply}
                      setCurrentReply={props.setCurrentReply}
                      setCurrentComment={props.setCurrentComment}
                      handleUpdateComment={props.handleUpdateComment}
                      updateCourseComment={props.updateCourseComment}
                      isEditCommentDisabled={props.isEditCommentDisabled}
                      isReplyCommentDisabled={props.isReplyCommentDisabled}
                    />
                  ) : (
                    <p className='comment-message replying-item-mobile'>
                      {item.comment}
                    </p>
                  )}{' '}
                </div>

                <span
                  style={{
                    marginRight: '4px',
                    float: 'right',
                    marginTop: '4px',
                  }}
                >
                  {language.discussions
                    ? language.discussions.submitted_on
                    : null}{' '}
                  {item.updated_at.split('T')[0] +
                    ', at ' +
                    item.updated_at.split('T')[1].substring(0, 5)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    ))
  ) : (
    <div className='row'>
      <div className='col-2'>
        <div className='border-div border-collapsed-replies'></div>
      </div>
      <div className='col-10'>
        <div className='row collapsed-replies'>
          <div className='col-2'>
            <div className='topic-avatar-wrapper'>
              <img
                src={firstReply.avatar ? firstReply.avatar.url : defaultAvatar}
                alt='avatar'
                className='avatar-fit'
              />
            </div>
          </div>
          <div className='col-10'>
            <div className='topic-item-info'>
              <div className='comment-data collapsed-data'>
                <span className='comment-user'>
                  {firstReply.first_name ? firstReply.first_name : null}{' '}
                  {firstReply.first_name ? firstReply.last_name : null}
                </span>
                {props.replies.length && props.replies.length >= 2 ? (
                  <span>
                    and {props.replies.length && props.replies.length - 1}{' '}
                    others replied to this.
                  </span>
                ) : (
                  <span>replied to this</span>
                )}
                {/* leart2 */}
                <span
                  onClick={() => {
                    dispatch(setCurrentComment(props.parentComment))
                    dispatch(handleCollapsed(props.parentComment))
                  }}
                  className='view-more-replies'
                >
                  {props.replies.length &&
                    'View ' +
                      props.replies.length +
                      (props.replies.length === 1
                        ? ' more reply'
                        : ' more replies...')}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const ReplyCommentTextbox = (props) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  const handleKeyDownReply = (event, replyItem) => {
    event.preventDefault()
    event.stopPropagation()
    dispatch(addCommentReplies(event.target.value, replyItem))
  }

  const handleReply = () => {
    if (loading) return

    setLoading(true)
    dispatch(
      addReplyOnClick(props.replyingTo, () => {
        setLoading(false)
      })
    )
  }

  let language = {}
  if (props.language) {
    language = props.language
  }

  const replyingTo = props.replyingTo
    ? props.replyingTo.first_name + ' ' + props.replyingTo.last_name
    : null

  return (
    <div className='row new-comment-card reply-comment-card'>
      <p className='reply-to '>
        Replying to <span>{replyingTo}</span>{' '}
        <span
          onClick={() => dispatch(setReplyTextboxActive(false))}
          className='cancel-reply'
        >
          {language.general ? language.general.cancel : null}
        </span>
      </p>
      <div className='col-12 '>
        <div className='position-relative'>
          <textarea
            name='comment'
            autoFocus
            rows='1'
            className='w-100 bg-white p-3 m-1 rounded'
            onChange={(event) => dispatch(onChangeComment(event.target.value))}
            defaultValue={props.comment}
            onKeyDown={(event) =>
              event.key === 'Enter'
                ? handleKeyDownReply(event, props.replyingTo)
                : null
            }
            disabled={props.isReplyCommentDisabled}
            style={{ resize: 'none', fontSize: '14px' }}
          ></textarea>
          <span className='send-button-update text-dark' onClick={handleReply}>
            <FontAwesomeIcon icon={faPaperPlane} />
          </span>
        </div>
      </div>
    </div>
  )
}

const UpdateReplyTextbox = (props) => {
  const dispatch = useDispatch()

  const handleKeyDown = (event, commentId) => {
    event.preventDefault()
    event.stopPropagation()
    dispatch(updateCourseComment(commentId))
  }
  return (
    <div>
      <textarea
        name='comment'
        autoFocus
        className='w-100 bg-white p-3 m-1 rounded'
        rows='1'
        onChange={(event) => dispatch(onChangeComment(event.target.value))}
        defaultValue={props.currentReply.comment}
        onKeyDown={(event) =>
          event.key === 'Enter'
            ? handleKeyDown(event, props.currentReply.id)
            : null
        }
        disabled={props.isReplyCommentDisabled}
        onFocus={function (e) {
          var val = e.target.value
          e.target.value = ''
          e.target.value = val
        }}
        style={{ resize: 'none', fontSize: '14px' }}
      ></textarea>
      <span
        className='send-button-update'
        style={{ cursor: 'pointer' }}
        onClick={() => dispatch(updateCourseComment(props.currentReply.id))}
      >
        <FontAwesomeIcon icon={faPaperPlane} />
      </span>
    </div>
  )
}

const NewCommentTextbox = (props) => {
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)

  const handleKeyDown = (event) => {
    event.preventDefault()
    event.stopPropagation()

    if (loading) return

    setLoading(true)
    dispatch(addCourseComment(setLoading(false)))
  }

  const handleNewComment = () => {
    if (loading) return

    setLoading(true)
    dispatch(addCourseComment(() => setLoading(false)))
  }

  return (
    <div className='row new-comment-card d-flex align-items-center '>
      <div className='col-2'>
        <User
          first_name={props.user && props.user.first_name}
          last_name={props.user && props.user.last_name}
          avatar={props.user && props.user.avatar && props.user.avatar.url}
          hideAvatar={null}
        />
      </div>
      <div className='col-10'>
        <textarea
          name='comment'
          className='w-100 bg-white p-3 m-1 mt-4 rounded'
          rows='1'
          autoFocus
          onChange={(event) => dispatch(onChangeComment(event.target.value))}
          value={props.comment}
          placeholder='Leave a comment...'
          onKeyDown={(event) =>
            event.key === 'Enter' ? handleKeyDown(event) : null
          }
          disabled={props.isNewCommentDisabled}
          style={{ resize: 'none' }}
        ></textarea>
        <div className='text-right'>
          <button className='btn btn-info' onClick={handleNewComment}>
            Submit
          </button>
          <button
            onClick={() => dispatch(setNewCommentTextboxActive(false))}
            className='btn btn-white'
            style={{ marginLeft: '10px' }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}

const Avatar = (props) => (
  <div className='topic-avatar-wrapper'>
    <img src={Image} alt='user' />
  </div>
)

export const User = (props) => (
  <div className='topic-user'>
    {props.hideAvatar ? null : props.avatar ? (
      <img src={props.avatar} alt='avatar' />
    ) : (
      <Avatar />
    )}
    <div className='topic-user-info'>
      <h4>
        {props.first_name} {props.last_name}
      </h4>
    </div>
  </div>
)

export default DiscussionForum
